import React, { useLayoutEffect } from 'react';
import { Alert } from '@biq/apex-ui';
import { Box, Typography } from '@mui/material';
import { AlertProps, styles } from './alert-context-helper';
import { ellipsifyTextInTwoLines } from 'lib';

export const CustomAlert = (alertProps: AlertProps): React.JSX.Element => {
    const errorMessageRef = React.useRef<HTMLDivElement>(null);
    const [isMultiline, setIsMultiline] = React.useState(false);

    useLayoutEffect(() => {
        const checkMultiline = (el: HTMLDivElement | null): boolean =>
            !!el && el.clientHeight > 20;

        const fieldMultiline = checkMultiline(errorMessageRef.current);

        setIsMultiline(fieldMultiline);
    }, [errorMessageRef.current, alertProps]);

    const handleDetailsClicked = (): void => {
        alertProps.onShowDetailsClicked?.();
    };

    return (
        <Alert {...alertProps} autoHide={true} sx={styles.alert}>
            {alertProps?.details ? (
                <div
                    style={{
                        ...styles.detailsContainer,
                        flexWrap: isMultiline ? 'wrap' : undefined,
                        gap: isMultiline ? '5px' : '10px',
                    }}
                >
                    <Box ref={errorMessageRef} sx={ellipsifyTextInTwoLines}>
                        {alertProps?.children}
                    </Box>
                    {JSON.parse(alertProps?.details)?.details && (
                        <Typography
                            sx={styles.detailsText}
                            onClick={handleDetailsClicked}
                        >
                            View Details
                        </Typography>
                    )}
                </div>
            ) : (
                alertProps?.children
            )}
        </Alert>
    );
};
